<template>
  <div
    class="scroll_container"
    @scroll="scrollHandler"
    :style="{ width, height }"
  >
    <slot></slot>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "CustomScroll",
  props: {
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    }
  },
  data() {
    return {};
  },
  computed: {
    scrollHandler() {
      return _.throttle(this.throttle_scrollHandler, 300);
    }
  },
  methods: {
    throttle_scrollHandler(e) {
      // console.dir(e)
      const clientHeight = e.target.clientHeight;
      const scrollHeight = e.target.scrollHeight;
      this.$emit("scroll", e);
      if (e.target.scrollTop === 0) {
        this.$emit("scrollStart", e);
      }
      if (scrollHeight - clientHeight === e.target.scrollTop) {
        this.$emit("scrollEnd", e);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.scroll_container {
  // width: calc(100% - 200px);
  // height: calc(100vh - 677px);
  /deep/ p {
    // margin: 15px 0;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  /deep/ img {
    line-height: 0;
  }
  padding-right: 10px;
  overflow: auto;
  &::-webkit-scrollbar {
    //隐藏滚轮display: none;
    width: 6px;
    height: 6px;
    background: none;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(175, 175, 175, 0.8);
    border-radius: 50px;
  }

  &::-webkit-scrollbar-track-piece {
    display: none;
  }
  &::-webkit-scrollbar-button {
    display: none;
  }
  &::-webkit-scrollbar-track {
    display: none;
  }
  &::-webkit-scrollbar-corner {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom_scroll.vue